import React, { useMemo } from 'react'

import { Section, Row, Left, Right } from 'components/BusinessCard/components/StyledComponents'
import { useBusinessCard } from 'components/BusinessCard/context'
import { PERSON_TYPE } from '../constants'

const Tags = () => {
  const { cardMeta: { showOnlyFields, showEmptyFields }, resource, resourceType } = useBusinessCard()

  const fieldName = resourceType === PERSON_TYPE ? 'predefined_contacts_tag_ids' : 'tag_ids'
  const tags = useMemo(() => resourceType === PERSON_TYPE ? resource.predefined_contacts_tags : resource.tags, [resource, resourceType])

  if (!showOnlyFields.includes(fieldName)) return null
  if (!showEmptyFields && (!tags || !tags.length)) return null

  return (
    <Section>
      <Row>
        <Left>Tags</Left>
        <Right>
          {tags.map(t => t.name).join(', ')}
        </Right>
      </Row>
    </Section>
  )
}

export default Tags
